/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ad_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select an audio file..." |
*
* @param {Audio_Embed_Export_Ad_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ad_placeholder = /** @type {((inputs?: Audio_Embed_Export_Ad_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ad_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un fichier audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Audiodatei aus...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите аудиофайл...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un archivo de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择一个音频文件……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声ファイルを選択してください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक ऑडियो फ़ाइल चुनें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um arquivo de áudio...")
	return /** @type {LocalizedString} */ ("Select an audio file...")
});